import React, { useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import './Carousel.css'
import Product from '../Products/Product'

const HEADING_ROUTES = {
  'Dog Food': '/DogProducts',
  'Cat Food': '/CatProducts',
}

const Carousel = (props) => {
  const items = props.data
  const scrollRef = useRef(null)
  const navigate = useNavigate()

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      })
    }
  }

  const route = HEADING_ROUTES[props.heading]

  return (
    <div className='carousel'>
        <h1>{props.heading}</h1>
        <hr />

        <div className="carousel-wrapper">
          <button className="carousel-arrow carousel-arrow-left" onClick={() => scroll('left')}>&#8249;</button>

          <div className="carousel-product" ref={scrollRef}>
              { 
                  items.slice(0, 15).map( (item, i)=>{
                      return <Product key={i} id={item.id} name={item.name} image={item.image} price={item.price} inStock={item.inStock} />
                  } ) 
              }
          </div>

          <button className="carousel-arrow carousel-arrow-right" onClick={() => scroll('right')}>&#8250;</button>
        </div>

        {route && (
          <button className='carousel-view-more' onClick={() => navigate(route)}>
            View More
          </button>
        )}

    </div>
  )
}

export default Carousel
